import React, { useState, useEffect , useRef , useContext } from 'react';
// import '../royal.css';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import { CountryContext } from './CountryContext';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import emailjs from 'emailjs-com';



const interests = [
  { label: 'Land Package', value: 'Land Package' },
  { label: 'Transfer', value: 'Transfer' },
  { label: 'Land + Cruise Package', value: 'land+cruise package' },
  { label: 'Hotel', value: 'hotel' },
  { label: 'Flight', value: 'Flight' }
];

  // const phoneNumbers = {
  //   USD: '(+91) 920 503 0318',
  //   INR: '(+91) 920 503 0318',
  //   SGD: '(+65) 8123 7473'
  // };



const Int2specialform = ({ leadsource }) => {

     const country = useContext(CountryContext);
    
 const countryname = country.countryName;

  const inputRef = useRef(null);  // For DOM node
const itiRef = useRef(null); 


 const [gclid, setGclid] = useState('');
  
    const [utmParams, setUtmParams] = useState({
     utm_source: '',
     utm_medium: '',
     utm_campaign: '',
     utm_term: '',
     utm_content: ''
   });

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    dialCode: "",
    nationalNumber: "",
    country:"",
    leadsource: "Cruise From Singapore",
    leadvariation: leadsource || "Int2special-Form",
    monthOfTravel: "",
    passengers: "",
    message:"",
    destination: "singapore",
    interest: [],
    utm_source: "",
    utm_medium: "",
    utm_campaign:"" ,
    utm_term:"",
    utm_content: "",
    zc_gad: ""
  });


  useEffect(() => {
    if (countryname) {
      setFormData(prev => ({ ...prev, country: countryname }));
    }
  }, [countryname]);


  const [showPopup, setShowPopup] = useState(false);  
  const [loading, setLoading] = useState(false);  
  
useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utm= {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || ''
    };
    
    const gclidValue = params.get('gclid') || '';
    setUtmParams(utm);
    setGclid(gclidValue);

   setFormData((prevData) => ({
    ...prevData,
    ...utm,
    zc_gad: gclidValue
  }));

  }, [gclid]);


useEffect(() => {
  const input = inputRef.current;

  if (!input) return;

  const iti = intlTelInput(input, {
    initialCountry: "in",
    preferredCountries: ["in", "us", "gb", "ae"],
    separateDialCode: true,
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
  });

  itiRef.current = iti;

  const updatePhoneNumber = () => {
    const phone = iti.getNumber();
    setFormData((prev) => ({ ...prev, mobile: phone }));
  };

  input.addEventListener("blur", updatePhoneNumber);
  input.addEventListener("countrychange", updatePhoneNumber);

  return () => {
    input.removeEventListener("blur", updatePhoneNumber);
    input.removeEventListener("countrychange", updatePhoneNumber);
    iti.destroy();
  };
}, []);


  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

    const handleChange = (e) => {
    const { name, value,  checked } = e.target;

    if (name === 'interest') {
      setFormData((prev) => {
        const updated = checked
          ? [...prev.interest, value]
          : prev.interest.filter((i) => i !== value);
        return { ...prev, interest: updated };
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🟡 Ensure phone number is updated before form submit
  const phone = itiRef.current?.getNumber();
  if (phone) {
    setFormData((prev) => ({ ...prev, mobile: phone }));
  }

  console.log("Submitting mobile:", phone); // Log actual phone number

  const form = new FormData();
  for (const key in formData) {
    if (key === "interest") {
      form.append(key, formData[key].join(", "));
    } else {
      form.append(key, formData[key]);
    }
  }

  setLoading(true);

    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycbw5srOZL1smFmpbXTR7UUIKHMVxZ664MJZEjaTn968HhXgSGbN4q3bx4uh33CnfTEBoBA/exec", {
        method: "POST",
        body: form
      });

      await emailjs.send(
      'service_gkjf62i',
      'template_t3u176h',
      {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        dialCode: formData.dialCode,
        nationalNumber: formData.nationalNumber,
        country: formData.country,
        leadsource: formData.leadsource, 
        leadvariation: formData.leadvariation,
        monthOfTravel: formData.monthOfTravel,
        passengers: formData.passengers,
        message:formData.message,
        destination: formData.destination,
        interest: formData.interest,
        utm_source: formData.utm_source,
        utm_medium: formData.utm_medium,
        utm_campaign: formData.utm_campaign,
        utm_term: formData.utm_term,
        utm_content: formData.utm_content,
        zc_gad:  formData.zc_gad
      },
      'eg06L6EKyPge0oB5Y'
    );

      if (response.ok) {
    
        setShowPopup(true); 

   
      } else {
        alert("There was an error submitting the form.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form!");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <div>
      <div className="form-container">
        <form onSubmit={handleSubmit} className="form-box">
          {/* <h2 className="form-title">REQUEST A AZAMARA QUOTE</h2> */}
       <center>
        <h2 class="modal-title fs-5" id="staticBackdropLabel">Request A Quote
        {/* {`${phoneNumbers[currency.currencyCode]}`} */}
        </h2>
        <p style={{color:'white',marginTop:'-3vh',fontSize:'1.1rem'}}>Int2Cruises Singapore Special Fares</p></center>

        <div className='align'>
          <div className="form-group ">
            <label>First Name *</label>
            <input
              type="text"
              name="firstName"
              onChange={handleChange}
              placeholder="First Name"
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              name="lastName"
              onChange={handleChange}
              placeholder="Last Name"
              required
            />

            </div>

            </div>
      
        <div className='align align2'>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              onChange={handleChange}
              placeholder="Email"
              required
            />
          </div>

          <div className="form-group">
            <label>Phone *</label>
            {/* <input */}
  {/* type="tel" */}
  {/* name="mobile" */}
  {/* // ref={inputRef} */}
  {/* onChange={handleChange} */}
  {/* placeholder="phone" */}
  {/* required */}
  {/* // className="form-control" */}
{/* /> */}
      <PhoneInput
     international
          defaultCountry={country.countryCode}
          // value={value}
          // onChange={setValue}
          value={formData.mobile}
          onChange={(phone) => {
            //  const cleaned = phone.replace(/\s|-/g, '');
    const parsed = parsePhoneNumberFromString(phone || '');
    
      // Match +[1 to 4 digit dial code] followed by 6 to 14 digits of national number
      // const match = cleaned.match(/^(\+\d{1,4})(\d{6,14})$/);
          // const match = phone.match(/^(\+\d{1,4})(\d{6,15})$/); // splits +code and number
          // const dialCode = match?.[1] || '';
          // const nationalNumber = match?.[2] || '';
            if (parsed && parsed.countryCallingCode && parsed.nationalNumber) {
        setFormData(prev => ({
          ...prev,
          mobile: phone,
          dialCode: '+' + parsed.countryCallingCode,
          nationalNumber: parsed.nationalNumber
        }));
      }}}
          placeholder="enter your phone"
          className='phoneinput'
   
   />
          </div>

          </div>

    <div className='align'>
          <div className="form-group traveler">
            <label>No. of Travellers</label>
            <input
              type="number"
              name="passengers"
              onChange={handleChange}
              placeholder="Number of Travellers"
            />
          </div>
    

          <div className="form-group travel-month">
            <label>Travel Month</label>
            <input
              type="date"
              name="monthOfTravel"
              onChange={handleChange}
            />
          </div>

</div>
          {/* <div className="form-group">
            <label>Destination *</label>
            <input
              type="text"
              name="destination"
              onChange={handleChange}
              placeholder="Destination"
              required
            />
          </div> */}

        <div className="form-group checkbox">
            <label>Also Interested in *</label>
            {interests.map((item) => (
              <div key={item.value} style={{ marginBottom: '5px' } }className='checkbox-style'>
                
                  <input
                    type="checkbox"
                    name="interest"
                    value={item.value}
                    checked={formData.interest.includes(item.value)}
                    onChange={handleChange}
                  />{' '}
                  <label>
                  {item.label}
                </label>
              </div>
            ))}
          </div>

      <div className="form-group">
   <label htmlFor="message">Message</label>
   <textarea
     id="message"
    name="message"
    placeholder="Your message here..."
    rows="4"
    value={formData.message}
    onChange={handleChange}
   ></textarea>
 </div>

          
{/* Hidden UTM Fields */}
 <input type="hidden" name="utm_source" value={utmParams.utm_source} />
 <input type="hidden" name="utm_medium" value={utmParams.utm_medium} />
 <input type="hidden" name="utm_campaign" value={utmParams.utm_campaign} />
 <input type="hidden" name="utm_term" value={utmParams.utm_term} />
 <input type="hidden" name="utm_content" value={utmParams.utm_content} />
 <input type="hidden" id="zc_gad" name="zc_gad" value="" />
          

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>

      {/* Popup Animation */}
      {showPopup && (
        <div className="popup-container">
          <div className="popup-content">
            <h3>Thank you for your submission!</h3>
            <p>We will get back to you soon.</p>
            <button onClick={() => setShowPopup(false)} className="close-popup">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Int2specialform;